import {Store} from "vuex"
import AuthStore from "@/store/AuthStore"

export class LocalStoragePlugin {
  private static storageKey: string

  static init(storageKey: string) {
    this.storageKey = storageKey

    // Sync with local storage.
    const item = localStorage.getItem(storageKey)
    if (item) {
      const syncedState = JSON.parse(item)
      AuthStore.state = Object.assign(AuthStore.state, JSON.parse(atob(syncedState.auth)))
    }
  }

  static plugin(store: Store<any>) {
    store.subscribe((mutation, state) => {
      const syncedData = {auth: btoa(JSON.stringify(state.auth))}

      localStorage.setItem(LocalStoragePlugin.storageKey, JSON.stringify(syncedData))

      if (mutation.type === 'common/clear') {
        localStorage.removeItem(LocalStoragePlugin.storageKey)
      }
    })
  }
}
